import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';
const getBadgesSize = (props) => {
    switch (props.variant) {
        case 'number':
            return '24px';
        case 'dot':
        default:
            return '8px';
    }
};
export const StyledBadgeContainer = styled.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: ${getBadgesSize};
  height: ${getBadgesSize};

  line-height: 0;
  text-align: center;

  background-color: ${(props) => props.theme.colors.ui.error};

  border-radius: 100%;

  ${injectSpacing('margin')}
`;
export const StyledBadgeCount = styled.span `
  color: ${(props) => props.theme.colors.utility.white};

  ${(props) => injectTypography(props, props.children <= 100 ? 'copy2' : 'copy3')}
`;
//# sourceMappingURL=Badge.styles.js.map